import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appShowHidePassword]'
})
export class ShowHidePasswordDirective {
   shown = false;

 constructor(private el: ElementRef) {
     this.setup();
   }
 toggle(x: HTMLElement) {
     this.shown = !this.shown;
    //  $(this).toggleClass('fa-eye fa-eye-slash');
     if (this.shown) {
       this.el.nativeElement.setAttribute('type', 'text');
       x.className = 'fa fa-eye';
     } else {
       this.el.nativeElement.setAttribute('type', 'password');
       x.className = 'fa fa-eye-slash';
     }
   }

  //  $(".toggle-password").click(function() {

  //   $(this).toggleClass("fa-eye fa-eye-slash");
  //   var input = $($(this).attr("toggle"));
  //   if (input.attr("type") == "password") {
  //     input.attr("type", "text");
  //   } else {
  //     input.attr("type", "password");
  //   }
  // });

  changeType() {
    this.shown = !this.shown;
    if (!this.shown) {
      this.el.nativeElement.setAttribute('type', 'password');
    } else {
      this.el.nativeElement.setAttribute('type', 'text');
    }
  }

 setup() {
     const parent = this.el.nativeElement.parentNode;
     const divp = document.createElement('div');
     divp.className = 'input-group-append';
     const span = document.createElement('span');
     span.className = 'input-group-text';
     const i = document.createElement('l');
     i.className = 'fa fa-eye-slash';
     i.addEventListener('click', (event) => {
       this.toggle(i);
     });
     span.appendChild(i);
     divp.appendChild(span);
     parent.appendChild(divp);
   }
 }


 


// WEBPACK FOOTER //
// ./src/app/shared/show-hide-password.directive.ts